import script from "./CookieAgreementPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieAgreementPopup.vue?vue&type=script&lang=ts&setup=true"

import "./CookieAgreementPopup.vue?vue&type=style&index=0&id=742b718f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742b718f"]])

export default __exports__